import Http from "../Http";
import {AUTH_ROUTES, CLIENTS_ROUTES} from "../config/routes";
import * as action from "../store/actions/clients";
import {handleError, showFAlert, showSAlert} from "../utils/functions";
import {showAlert, showSuccessAlert} from "../store/actions/common";
import {addPurchases} from "../store/actions/clients";

export function getClients(params = {}) {
    const {page, rowPerPage, filters} = params || {};
    return dispatch => {
        dispatch(action.getClients({list: [], pagination: {}}));
        return new Promise((resolve, reject) => {
            Http.get(CLIENTS_ROUTES.getClients, {params: {page, rowPerPage, ...filters}})
                .then(res => {
                    dispatch(action.getClients(res.data));
                    return resolve();
                })
                .catch((err) => handleError(err, reject))
        })

    }
}

export function getSites() {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.get(CLIENTS_ROUTES.getSites)
                .then(res => {
                    dispatch(action.getSites(res.data));
                    return resolve();
                })
                .catch((err) => handleError(err, reject))
        })
    )
}

export function addClients(clients, site, services) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.put(CLIENTS_ROUTES.addClients, {clients, site, services})
                .then(res => {
                    if (res.status == 200 && !res.data.error){
                        showSAlert('Успех', res.data.message, dispatch)
                    } else {
                        showFAlert('Ошибка', res.data.message, dispatch)
                    }
                    return resolve();
                })
                .catch((err) => {
                    handleError(err, reject, dispatch)
                })
        })
    )
}

export function removeClients(clients) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.delete(CLIENTS_ROUTES.removeClients, {params: {clients}})
                .then(res => {
                    showSAlert('Успех', 'Аккаунты удалены', dispatch);
                    return resolve();
                })
                .catch((err) => {
                    handleError(err, reject, dispatch)
                })
        })
    )
}

export function changeLabelClient(client, name, label) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(CLIENTS_ROUTES.changeLabel, {client, text:label})
                .then(res => {
                    return Http.post(CLIENTS_ROUTES.changeName, {client, text:name})
                })
                .then(res => {
                    showSAlert('Успех', 'Имя и пометка изменены', dispatch);
                    return resolve();
                })
                .catch((err) => {
                    handleError(err, reject, dispatch)
                })
        })
    )
}
export function changeNameClient(client, text) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(CLIENTS_ROUTES.changeName, {client, text})
                .then(res => {
                    showSAlert('Успех', 'Имя изменено', dispatch);
                    return resolve();
                })
                .catch((err) => {
                    handleError(err, reject, dispatch)
                })
        })
    )
}


export function changePlan(clients, planId) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.put(CLIENTS_ROUTES.changePlan, {clients, planId})
                .then(res => {
                    showSAlert('Успех', 'Тарифный план изменен успешно', dispatch);
                    return resolve();
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}

export function lockClients(clients, locked) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(CLIENTS_ROUTES.lockClients, {clients, locked})
                .then(res => {
                    locked ? showSAlert('Успех', 'Продление запрещено', dispatch) : showSAlert('Успех', 'Продление разрешено', dispatch)
                    return resolve();
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}
export function lockCaptcha(clients, locked) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(CLIENTS_ROUTES.lockCaptcha, {clients, locked})
                .then(res => {
                    locked ? showSAlert('Успех', 'Капча заблокирована', dispatch) : showSAlert('Успех', 'Капча успешно разблокирована', dispatch)
                    return resolve();
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}
export function getPurchases(filters) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(CLIENTS_ROUTES.getPurchases, filters)
                .then(res => {
                    dispatch(addPurchases(res.data));
                    //res ? showSAlert('Успех', 'Капча заблокирована', dispatch) : showSAlert('Успех', 'Капча успешно разблокирована', dispatch)
                    return resolve();
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}

export function getNews() {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.get(CLIENTS_ROUTES.getNews)
                .then(res => {
                    dispatch(action.getNews(res.data));
                    return resolve();
                })
                .catch((err) => handleError(err, reject))
        })
    )
}